export const AUTH0_DOMAINS =
{
    'msci.com': 'MSCI-AD-SSO',
    'partstrader.com': 'PARTSTRADER-SSO',
    'partstrader.us.com': 'PARTSTRADER-SSO',
    'ptml.com': 'PARTSTRADER-SSO',
    'involveai.onmicrosoft.com': 'INVOLVE-AD'
};
